const methods = [
  {
    icon: 'ri-user-search-line',
    number: '01',
    title: 'Метод персонажей',
    text: 'Определяем, кто ваш клиент и «на каком языке» он говорит. Без понимания аудитории невозможно написать текст, который читают до конца.',
  },
  {
    icon: 'ri-map-pin-2-line',
    number: '02',
    title: 'Анализ Customer Journey Map (CJM)',
    text: 'Мы понимаем, на каком этапе пути находится читатель и какой ответ ему нужен прямо сейчас. Статья создаётся под конкретный момент принятия решения.',
  },
  {
    icon: 'ri-briefcase-4-line',
    number: '03',
    title: 'Методология Jobs to Be Done (JTBD)',
    text: 'Мы анализируем, на какую «работу» клиент нанимает ваш продукт, и создаем текст, который закрывает эту потребность.',
    note: 'Jobs to Be Done (JTBD) — методология, которая помогает понять, почему люди принимают решение о покупке. Переводится как «работа, которая должна быть сделана».',
  },
];

export default function SEOArticleStrategy() {
  return (
    <section id="seo-strategy" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/30 mb-5">
            <i className="ri-microscope-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Стратегический фундамент
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-5 leading-tight">
            Мы не пишем «для роботов».{' '}
            <span className="block sm:inline">Мы проектируем смыслы для людей.</span>
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Перед написанием первой строчки мы проводим маркетинговый рентген вашего бизнеса:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 sm:gap-6">
          {methods.map((m, i) => (
            <div key={i} className="relative bg-[#F8F9FA] rounded-2xl sm:rounded-3xl p-5 sm:p-8 border border-gray-100 hover:border-[#C5A880]/40 transition-all duration-300">
              <span className="absolute top-4 right-4 text-4xl sm:text-5xl font-bold text-[#1A2B4C]/06 font-['Playfair_Display'] select-none">
                {m.number}
              </span>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1A2B4C] rounded-xl flex items-center justify-center mb-4">
                <i className={`${m.icon} text-lg sm:text-xl text-white`}></i>
              </div>
              <h3 className="text-base sm:text-xl font-bold text-[#1A2B4C] mb-3 font-['Playfair_Display'] leading-snug">
                {m.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-['Montserrat'] mb-3 text-justify">
                {m.text}
              </p>
              {m.note && (
                <div className="mt-4 border-t border-gray-200 pt-3">
                  <p className="text-xs text-gray-400 italic leading-relaxed font-['Montserrat'] text-justify">
                    *** {m.note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
